import config from "../config";
const base_url = config.base_url;
export const editPartner = async (files, data) => {
  //files is an array containing all the files the user wants to upload
  //for getting the files, you need to use an <input/> using "multiple" property.
  //Then, using the onChange method, you need to assign the selected files into an array this way:
  // const [files, setFiles] = useState()
  //onChange ={(e)=>setFiles(e.target.files)}

  const formData = new FormData();
  for (let file of files) {
    formData.append("file", file);
  }
  formData.append("data", JSON.stringify(data));

  return fetch(base_url + "admin/partners/edit/partner", {
    method: "POST",
    mode: "cors",
    credentials: "include",
    body: formData,
  });
};
